import { GoogleConnectRefusal } from '@this+that/models';

import { resolveRestErrorKey } from './restErrors';

const REFUSAL_MESSAGE_KEYS: ReadonlyMap<string, string> = new Map([
  [
    GoogleConnectRefusal.ACCOUNT_HELD_BY_ANOTHER_USER,
    'integration.googleAccountHeldByAnotherUser',
  ],
]);

// Every caller that schedules a Google connect renders one generic failure toast, so a
// refusal the backend spelled out reaches the user as "something went wrong" without this.
export const resolveGoogleConnectErrorKey = (
  error: unknown,
  fallbackKey: string,
): string => resolveRestErrorKey(error, REFUSAL_MESSAGE_KEYS, fallbackKey);
